module.exports = __webpack_public_path__ + "static/media/percentage-radio-button-unselected.162cea1f.svg";